export default __webpack_public_path__ + "static/media/Neovera-6-ban.135288b6.jpg";